import axios from "axios";

const client = axios.create();
client.defaults.baseURL = "/";

const register = (companyTitle,
                  taxAdministration,
                  taxNumber,
                  city,
                  district,
                  dealerAddress,
                  storeLink,
                  hasTradeAuthorizationCertificate,
                  tradeAuthorizationCertificateNumber,
                  tradeAuthorizationCertificateDate,
                  companyOwnerName,
                  companyOwnerSurname,
                  tcNo,
                  birtdate,
                  email,
                  mobilePhone,
                  phoneNumber,
                  companyManagerName,
                  companyManagerSurname,
                  companyManagerTcNo,
                  companyManagerBirtdate,
                  membershipContract,
                  disclosure,
                  dataProcess,
                  etkPermission,
                  password,
                  againPassword,
                  createDate) =>
    client({
        method: 'POST',
        url: 'CreditSystem/dealer/',
        data:
            {
                "company": {
                    "address": dealerAddress,
                    "city": city,
                    "commerceChamber": null,
                    "commerceRegisterNo": null,
                    "confirmTaxPlate": null,
                    "district": district,
                    "foundationDate": null,
                    "id": 0,
                    "name": companyTitle,
                    "phoneNumber": phoneNumber,
                    "taxNo": taxNumber,
                    "taxOffice": taxAdministration,
                    "title": null,
                    "email": email
                },
                "companyId": 0,
                "createDate": new Date(),
                "dealerList": [],
                "dealerPasswordRefresh": null,
                "dealerResponsible": null,
                "dealerResponsibleUid": null,
                "etkPermission": etkPermission,
                "ibanHolder": null,
                "ibanNo": null,
                "id": 0,
                "manager": {
                    "address": null,
                    "birthdate": companyManagerBirtdate,
                    "city": null,
                    "company": null,
                    "confirmTaxPlate": null,
                    "createDate": null,
                    "district": null,
                    "email": null,
                    "employmentStatus": null,
                    "explicitConsent": null,
                    "firstName": companyManagerName,
                    "gender": null,
                    "guid": null,
                    "homePhone": null,
                    "id": 0,
                    "identityNo": companyManagerTcNo,
                    "initialPassword": null,
                    "kvkk_notice": null,
                    "lastName": companyManagerSurname,
                    "maritalStatus": null,
                    "mobilePhone": null,
                    "mobilePhone2": null,
                    "numOfChildren": 0,
                    "password": null,
                    "profession": null,
                    "registeredCity": null,
                    "registeredDistrict": null,
                    "salary": 0,
                    "title": null,
                    "updateDate": null,
                    "workPhone": phoneNumber,
                    "workplace": null,
                    "workplaceAddress": null,
                    "workplaceCity": null,
                    "workplaceDistrict": null
                },
                "minDownPaymentRate": null,
                "partner": {
                    "address": null,
                    "birthdate": birtdate,
                    "city": null,
                    "company": null,
                    "confirmTaxPlate": null,
                    "createDate": null,
                    "district": null,
                    "email": email,
                    "employmentStatus": null,
                    "explicitConsent": null,
                    "firstName": companyOwnerName,
                    "gender": null,
                    "guid": null,
                    "homePhone": null,
                    "id": 0,
                    "identityNo": tcNo,
                    "initialPassword": password,
                    "kvkk_notice": null,
                    "lastName": companyOwnerSurname,
                    "maritalStatus": null,
                    "mobilePhone": mobilePhone,
                    "mobilePhone2": null,
                    "numOfChildren": 0,
                    "password": password,
                    "passwordAgain": againPassword,
                    "profession": null,
                    "registeredCity": null,
                    "registeredDistrict": null,
                    "salary": 0,
                    "title": null,
                    "updateDate": null,
                    "workPhone": phoneNumber,
                    "workplace": null,
                    "workplaceAddress": null,
                    "workplaceCity": null,
                    "workplaceDistrict": null

                },
                "partnerId": 0,
                "status": null,
                "statusComment": null,
                "statusReason": null,
                "webStoreUrl": storeLink,
                "hasTradeAuthorizationCertificate": hasTradeAuthorizationCertificate,
                "tradeAuthorizationCertificateNumber": tradeAuthorizationCertificateNumber,
                "tradeAuthorizationCertificateDate": tradeAuthorizationCertificateDate
            }
    }).then((response) => {
        console.log(response.data);
        return response.data;
    });

export default {
    register,
};
